import { render, staticRenderFns } from "./ChemUTS47LitQ1.vue?vue&type=template&id=6b64908e&scoped=true&"
import script from "./ChemUTS47LitQ1.vue?vue&type=script&lang=js&"
export * from "./ChemUTS47LitQ1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b64908e",
  null
  
)

export default component.exports